import { render, staticRenderFns } from "./colunas-3.vue?vue&type=template&id=3af2ae71&"
import script from "./colunas-3.vue?vue&type=script&lang=js&"
export * from "./colunas-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af2ae71')) {
      api.createRecord('3af2ae71', component.options)
    } else {
      api.reload('3af2ae71', component.options)
    }
    module.hot.accept("./colunas-3.vue?vue&type=template&id=3af2ae71&", function () {
      api.rerender('3af2ae71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/colunas-3.vue"
export default component.exports